import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";
import Slider from "react-slick";
import { Todos } from "../../Todos";
import { AlertDetails } from "./AlertDetails";
import { newAuthService } from "Service/Axios";
import { getStudentAlertsUrl } from "Constant/api";
import { useApplicantProjectList } from "Constant/apiHooks";
import { paths } from "Constant/paths";
import { formatDateWithFullMonthTime } from "Utils";

// Test
const settings = {
  infinite: false,
  dots: false,
  variableWidth: false,
  focusOnSelect: true,
  speed: 500,
  slidesToShow: 3.5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function StudentDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [alertDetailsModal, setAlertDetailsModal] = useState(false);
  const [alertId, setAlertId] = useState("");
  const [alertList, setAlertList] = useState([]);

  const { applicantProjectList: applicationList } = useApplicantProjectList();

  // Toggle
  const toggleAlertDetailsModal = (gid) => {
    setAlertDetailsModal(!alertDetailsModal);
    if (gid) {
      setAlertId(gid);
    } else {
      setAlertId("");
    }
  };

  // Listing
  const getAlertList = async () => {
    try {
      const payload = {};
      const response = await newAuthService(
        getStudentAlertsUrl,
        "POST",
        payload
      );
      if (response.status) {
        setAlertList(response.data);
      } else {
        setAlertList([]);
      }
    } catch {
      toast.error(t("common.messages.notification.failed.serverError"));
    }
  };

  useEffect(() => {
    getAlertList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // On Click
  const handleRedirectToFormApplication = (formId, urlParameter, appId) => {
    if (urlParameter && appId) {
      navigate(
        `${paths.formBuilder.applicationForm}/${formId}?${urlParameter}&appId=${appId}`
      );
    } else if (!urlParameter && appId) {
      navigate(`${paths.formBuilder.applicationForm}/${formId}?appId=${appId}`);
    } else if (urlParameter && !appId) {
      navigate(
        `${paths.formBuilder.applicationForm}/${formId}?${urlParameter}`
      );
    } else {
      navigate(`${paths.formBuilder.applicationForm}/${formId}`);
    }
  };

  //   const handleRedirectToFormInstruction = (formId, urlParameter) => {
  //     if (urlParameter) {
  //       navigate(`${paths.formInstruction}/${formId}?${urlParameter}`);
  //     } else {
  //       navigate(`${paths.formInstruction}/${formId}`);
  //     }
  //   };

  return (
    <main className="main">
      <div className="d-flex flex-column gap-2 mb-4">
        {alertList &&
          alertList.length > 0 &&
          alertList.map((alert) => (
            <div
              className="p-2 rounded-lg bg-white shadow-sm d-flex align-items-center gap-2"
              key={alert.gid}
            >
              <div
                className={`w-12 h-12 flex-auto text-white text-center rounded-md bg-${
                  alert.type === "Congratulations"
                    ? "green"
                    : alert.type === "Action"
                    ? "orange"
                    : "red"
                }-500 d-flex justify-content-center align-items-center`}
              >
                <span className="material-symbols-outlined">mail</span>
              </div>
              <span className="text-sm text-slate-500">
                <strong>{alert.typeText}!</strong> {alert.firstText}{" "}
                {alert.highlightText} {alert.secondText}
              </span>
              <button
                onClick={() => toggleAlertDetailsModal(alert.gid)}
                className="ms-auto btn text-slate-600 bg-slate-100"
              >
                View Details
              </button>
            </div>
          ))}
      </div>

      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="card custom-card card-shadow rounded-2 border-0 card-light-gray mb-4">
            <div className="card-header d-flex align-items-center">
              <h3 className="card-title font-semibold">
                {t("auth.studentDashboard.admissionStatus")}
              </h3>
              {/* <a href="#" className="btn btn-primary btn-sm ms-auto">Show all</a> */}
            </div>
            <div className="card-body">
              {/* <h4 className="card-sub-title">Program</h4> */}
              <ul className="list-group list-group-flush mb-4">
                {applicationList &&
                  applicationList.length > 0 &&
                  applicationList.map((application, index) => (
                    <li className="list-group-item p-3" key={index.toString()}>
                      <div className="list-table admission-status-table">
                        <div
                          role="button"
                          className="list-tr"
                          onClick={() =>
                            handleRedirectToFormApplication(
                              application.formId,
                              undefined,
                              application.appId
                            )
                          }
                        >
                          {/* <div className="list-td icon-td">
                            <div className="td-icon-box">
                              <i className="bx bxs-envelope"></i>
                            </div>
                          </div> */}
                          <div className="list-td me-2">
                            <h4>{application.formName}</h4>
                            {/* <span className="duration">N/a</span> */}
                          </div>
                          <div className="list-td ps-md-2">
                            <span className="date">
                              {application.submitDate &&
                                formatDateWithFullMonthTime(
                                  application.submitDate
                                )}
                            </span>
                          </div>
                          <div className="ms-auto d-flex justify-content-between align-items-center status-group">
                            <span className="status-tag status-tag-success rounded-pill me-3">
                              {application.status}
                            </span>

                            <Dropdown align={{ lg: "end" }}>
                              <Dropdown.Toggle
                                className="p-0 status-more-btn"
                                id="dropdown-basic"
                              >
                                <i className="bx bx-dots-vertical-rounded"></i>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {/* <Dropdown.Item href="#">
                                  Edit form
                                </Dropdown.Item> */}
                                <Dropdown.Item
                                  href={`${paths.formBuilder.applicationForm}/${application.formId}`}
                                >
                                  {t("common.button.view")}
                                </Dropdown.Item>
                                {/* <Dropdown.Item href="#">
                                  Download pdf
                                </Dropdown.Item> */}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>

              {/* <h4 className="card-sub-title">Certificate Courses</h4>
              <ul className="list-group list-group-flush">
                <li className="list-group-item p-3">
                  <div className="list-table admission-status-table">
                    <div className="list-tr">
                      <div className="list-td icon-td">
                        <div className="td-icon-box">
                          <i className="bx bxs-envelope"></i>
                        </div>
                      </div>
                      <div className="list-td">
                        <h4>Certificate in Information Security</h4>
                        <span className="duration">Duration : 6 months</span>
                      </div>
                      <div className="list-td ps-md-2">
                        <span className="date">June 11, 2022</span>
                      </div>
                      <div className="ms-lg-auto d-flex justify-content-between align-items-center status-group">
                        <span className="status-tag status-tag-pending rounded-pill me-3">
                          Pending
                        </span>
                        <button type="button" className="status-more-btn">
                          <i className="bx bx-dots-vertical-rounded"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item p-3">
                  <div className="list-table admission-status-table">
                    <div className="list-tr">
                      <div className="list-td icon-td">
                        <div className="td-icon-box">
                          <i className="bx bxs-envelope"></i>
                        </div>
                      </div>
                      <div className="list-td">
                        <h4>Appreciation course in Environment</h4>
                        <span className="duration">Duration : 3 months</span>
                      </div>
                      <div className="list-td">
                        <span className="date">MAY 26, 2022</span>
                      </div>
                      <div className="ms-lg-auto d-flex justify-content-between align-items-center status-group">
                        <span className="status-tag status-tag-pending rounded-pill me-3">
                          Pending
                        </span>
                        <button type="button" className="status-more-btn">
                          <i className="bx bx-dots-vertical-rounded"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul> */}
            </div>
          </div>

          <Todos />
          {/* <div className="card custom-card card-shadow rounded-2 border-0 card-light-gray mb-4">
            <div className="card-header d-flex align-items-center">
              <h3 className="card-title font-semibold">Social Tab</h3>
              <div className="circle-icon ms-auto">
                <i className="bx bx-right-arrow-alt"></i>
              </div>
            </div>
            <div className="card-body">
              <div className="editor-box social-comment p-3 bg-white mb-4 rounded-2">
                <div className="avatar-img me-2">
                  <div className="img-box">
                    <img src="/assets/images/avatars/5.jpg" alt="" />
                  </div>
                  <div className="short-name">TC</div>
                </div>
                <div className="text-editor mb-3">
                  <div contenteditable="true" id="selectable"></div>
                </div>
                <div className="editor-tools-bar">
                  <div className="editor-tools-icons">
                    <ul>
                      <li>
                        <button type="button">
                          <i className="bx bx-image"></i>
                        </button>
                      </li>
                      <li>
                        <button type="button">
                          <i className="bx bxs-file-gif"></i>
                        </button>
                      </li>
                      <li>
                        <button type="button">
                          <i className="bx bx-smile"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="send-btn-box">
                    <button
                      className="btn btn-purple text-uppercase"
                      type="submit"
                    >
                      Post
                    </button>
                  </div>
                </div>
              </div>

              <div className="row socialpost-list g-3">
                <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                  <div className="socialpost-box rounded-2">
                    <div className="socialpost-header d-flex">
                      <div className="d-flex align-items-center user-details">
                        <div className="avatar-img me-2">
                          <div className="img-box">
                            <img src="/assets/images/avatars/5.jpg" alt="" />
                          </div>
                        </div>
                        <div className="social-uer-name">
                          <h4 className="user-name">Alex Collin</h4>
                          <span className="user-emailid">@alexcol</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="social-follow-btn ms-auto"
                      >
                        <i className="bx bxs-plus-circle"></i> Follow
                      </button>
                    </div>

                    <div className="socialpost-body">
                      <p>
                        It is a long established fact that a reader will be
                        distracted{" "}
                      </p>
                      <div className="socialpost-img">
                        <img src="/assets/images/items/post-img.jpg" alt="" />
                      </div>
                      <ul className="social-btns">
                        <li>
                          <button type="button">
                            <i className="bx bx-heart"></i>
                          </button>
                        </li>
                        <li>
                          <button type="button">
                            <i className="bx bx-message"></i>
                          </button>
                        </li>
                        <li>
                          <button type="button">
                            <i className="bx bx-send"></i>
                          </button>
                        </li>
                      </ul>

                      <span className="line-qty">
                        Liked by <strong> salomeblanc</strong> and{" "}
                        <strong>26 others</strong>
                      </span>
                    </div>

                    <div className="socialpost-footer">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Write a comment"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                  <div className="socialpost-box rounded-2">
                    <div className="socialpost-header d-flex">
                      <div className="d-flex align-items-center user-details">
                        <div className="avatar-img me-2">
                          <div className="short-name">AR</div>
                        </div>
                        <div className="social-uer-name">
                          <h4 className="user-name">Amanda Rodgers</h4>
                          <span className="user-emailid">@amanda</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="social-follow-btn ms-auto"
                      >
                        <i className="bx bxs-plus-circle"></i> Follow
                      </button>
                    </div>

                    <div className="socialpost-body">
                      <p>
                        It is a long established fact that a reader will be
                        distracted{" "}
                      </p>
                      <div className="socialpost-img">
                        <img src="/assets/images/items/post-img.jpg" alt="" />
                      </div>
                      <ul className="social-btns">
                        <li>
                          <button type="button">
                            <i className="bx bx-heart"></i>
                          </button>
                        </li>
                        <li>
                          <button type="button">
                            <i className="bx bx-message"></i>
                          </button>
                        </li>
                        <li>
                          <button type="button">
                            <i className="bx bx-send"></i>
                          </button>
                        </li>
                      </ul>

                      <span className="line-qty">
                        Liked by <strong> salomeblanc</strong> and{" "}
                        <strong>26 others</strong>
                      </span>
                    </div>

                    <div className="socialpost-footer">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Write a comment"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        {/* <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="card custom-card card-shadow rounded-2 border-0 card-light-gray mb-4">
            <div className="card-header d-flex align-items-center">
              <h3 className="card-title font-semibold">Notification</h3>
              <div className="circle-icon ms-auto">
                <i className="bx bx-right-arrow-alt"></i>
              </div>
            </div>
            <div className="card-body">
              <ul className="notification-list">
                <li>
                  <div className="notification-box d-flex">
                    <div className="avatar-img me-2">
                      <div className="img-box">
                        <img src="/assets/images/avatars/5.jpg" alt="" />
                      </div>
                      <div className="short-name">TC</div>
                    </div>
                    <div className="notofication-details">
                      <h6 className="notification-title">
                        Alex requested to follow <strong>you</strong>
                      </h6>
                      <div className="notification-btn-list">
                        <div className="btn btn-danger btn-sm me-2">Accept</div>
                        <div className="btn btn-light btn-sm">Reject</div>
                      </div>
                      <div className="date-time">Today at 9:42 AM</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="notification-box d-flex">
                    <div className="avatar-img me-2">
                      <div className="img-box">
                        <img src="/assets/images/avatars/6.jpg" alt="" />
                      </div>
                      <div className="short-name">TC</div>
                    </div>
                    <div className="notofication-details">
                      <h6 className="notification-title">
                        <strong>Ray Arnold</strong> left 6 message on{" "}
                        <strong>BBA Admission Form</strong>
                      </h6>
                      <div className="date-time">Yesterday at 11:42 PM</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="notification-box d-flex">
                    <div className="avatar-img me-2">
                      <div className="img-box">
                        <img src="/assets/images/avatars/8.jpg" alt="" />
                      </div>
                      <div className="short-name">TC</div>
                    </div>
                    <div className="notofication-details">
                      <h6 className="notification-title">
                        <strong>Dennis Nedry</strong> emailed on{" "}
                        <strong>Certificate in Information Security</strong>
                      </h6>
                      <div className="notification-text">
                        <p>
                          “It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout”
                        </p>
                      </div>
                      <div className="date-time">Yesterday at 5:42 PM</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="notification-box d-flex">
                    <div className="avatar-img me-2">
                      <div className="img-box">
                        <img src="/assets/images/avatars/9.jpg" alt="" />
                      </div>
                      <div className="short-name">TC</div>
                    </div>
                    <div className="notofication-details">
                      <h6 className="notification-title">
                        John Hammond invited you for{" "}
                        <strong>Nebular SOC2 research</strong>
                      </h6>
                      <div className="date-time">
                        Last Wednesday at 11:15 AM
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="card custom-card card-shadow rounded-2 border-0 card-light-gray mb-4">
            <div className="card-header d-flex align-items-center">
              <h3 className="card-title font-semibold">List of Faculties</h3>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush ">
                <li className="list-group-item p-3">
                  <div className="list-table">
                    <div className="list-tr">
                      <div className="list-td icon-td">
                        <div className="td-icon-box">
                          <i className="bx bxs-envelope"></i>
                        </div>
                      </div>
                      <div className="list-td">
                        <h4>Faculty of Arts</h4>
                        <span className="duration">
                          dean_arts@university.com
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item p-3">
                  <div className="list-table">
                    <div className="list-tr">
                      <div className="list-td icon-td">
                        <div className="td-icon-box">
                          <i className="bx bxs-envelope"></i>
                        </div>
                      </div>
                      <div className="list-td">
                        <h4>Faculty of Education</h4>
                        <span className="duration">
                          dean_arts@university.com
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item p-3">
                  <div className="list-table">
                    <div className="list-tr">
                      <div className="list-td icon-td">
                        <div className="td-icon-box">
                          <i className="bx bxs-envelope"></i>
                        </div>
                      </div>
                      <div className="list-td">
                        <h4>Faculty of Commerce</h4>
                        <span className="duration">
                          dean_arts@university.com
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item p-3">
                  <div className="list-table">
                    <div className="list-tr">
                      <div className="list-td icon-td">
                        <div className="td-icon-box">
                          <i className="bx bxs-envelope"></i>
                        </div>
                      </div>
                      <div className="list-td">
                        <h4>Faculty of Arts</h4>
                        <span className="duration">
                          dean_arts@university.com
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item p-3">
                  <div className="list-table">
                    <div className="list-tr">
                      <div className="list-td icon-td">
                        <div className="td-icon-box">
                          <i className="bx bxs-envelope"></i>
                        </div>
                      </div>
                      <div className="list-td">
                        <h4>Faculty of Education</h4>
                        <span className="duration">
                          dean_arts@university.com
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div> */}
      </div>

      {alertDetailsModal && (
        <AlertDetails
          show={alertDetailsModal}
          alertId={alertId}
          toggle={toggleAlertDetailsModal}
        />
      )}
    </main>
  );
}
